import React, { useRef, useState, useEffect } from 'react'

import { t } from '@/i18n'

import Button from './Button'

interface ISearch {
  onSearch: (text: string) => void
}

const Search: React.FC<ISearch> = ({ onSearch }) => {
  const timer = useRef<NodeJS.Timeout>()
  const [text, setText] = useState<string | undefined>(undefined)

  useEffect(() => {
    const debounce = text ? 300 : 0
    if (text !== null && text !== undefined) {
      timer.current = setTimeout(() => {
        onSearch(text)
      }, debounce)
    }

    return () => {
      if (timer.current) {
        clearTimeout(timer.current)
      }
    }
  }, [text, onSearch])

  return (
    <div className="info-search">
      <div className="search-item">
        <label>
          <input
            type="text"
            value={text}
            placeholder={t('search')}
            onChange={({ target: { value } }) => setText(value)}
          />
        </label>
        <Button>
          <span className="icon-search"></span>
        </Button>
      </div>
    </div>
  )
}

export default Search
